import { render, staticRenderFns } from "./ServicesAndBills.vue?vue&type=template&id=3feeb2ec"
import script from "./ServicesAndBills.vue?vue&type=script&lang=ts"
export * from "./ServicesAndBills.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports